module.exports = __webpack_public_path__ + "static/media/wheeled-BG-5th-layer-five@2x.666b13c1.png";